import type * as React from 'react';

import { Icon } from '@gitbook/spine-icons';
import { type MaybeHTTPError, sanitizeError } from '@gitbook/util-debug';

import { sizes } from '../../constants';

/**
 * Error message when one of the palette's group failed to compute commands.
 */
export function PaletteErrorMessage(props: { error: MaybeHTTPError }): React.ReactElement {
    const { error } = props;

    // biome-ignore lint/suspicious/noConsole: We want to log the full error here
    console.error(error);

    return (
        <div className="flex items-center gap-2 p-4">
            <Icon.Warning size={sizes.ICON_400} className="size-4 text-danger" />
            <div className="flex flex-1 items-center text-danger text-ui-base">
                {sanitizeError(error)}
            </div>
        </div>
    );
}
